// extracted by mini-css-extract-plugin
export default {"mobile-card":"eVP9R","mobile-card-content":"G53R","mobile-card-index":"AROFv","border-top":"lJL5w"};